<div
    class="landing-page min-h-screen bg-surface-0 text-surface-900 dark:bg-surface-950 dark:text-surface-0"
    [attr.dir]="direction()"
>
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
        <div class="absolute -top-32 left-1/2 h-80 w-80 -translate-x-1/2 rounded-full bg-primary-500/20 blur-3xl"></div>
        <div class="absolute top-32 right-[-6rem] h-72 w-72 rounded-full bg-primary-500/15 blur-3xl"></div>
        <div class="absolute bottom-0 left-[-5rem] h-72 w-72 rounded-full bg-surface-900/5 dark:bg-white/5 blur-3xl"></div>
    </div>

    <app-landing-starfield [particles]="spaceParticles" [stars]="shootingStars" />

    <div class="relative z-10">
        <app-landing-header
            [text]="text()"
            [language]="language()"
            [isDarkTheme]="!!isDarkTheme()"
            [activeSection]="activeSection()"
            (languageChange)="setLanguage($event)"
            (themeToggle)="toggleDarkMode()"
            (navigate)="scrollToSection($event)"
        />

        <main id="landing-main-content" tabindex="-1">
            <app-landing-intro [text]="text()" [particles]="spaceParticles" [stars]="shootingStars" />
            <app-landing-hero [text]="text()" (scrollTo)="scrollToSection($event)" />
            <app-landing-challenge [text]="text()" />
            <app-landing-work [text]="text()" />
            <app-landing-how [text]="text()" />
            <app-landing-fit [text]="text()" />
            <app-landing-benefits [text]="text()" />
            <app-landing-security [text]="text()" />
            <app-landing-info [text]="text()" />
            <app-landing-contact
                [text]="text()"
                [contactBenefitIcons]="contactBenefitIcons"
                [demoForm]="demoForm"
                [demoSubmitted]="demoSubmitted()"
                (submitDemo)="submitDemoRequest()"
            />
        </main>

        <app-landing-footer [text]="text()" (navigate)="scrollToSection($event)" />
    </div>
</div>

